"use strict";

import Page from "./components/SubscriptionPage.jsx";

export const auth = true;
export const title = "i18n:subscriptionPage.pageTitle";
export const Component = Page;
